import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUserId, setUsersListLoaded, setUserStateLoaded, resetAllLoaded, updateUserState, updateHelpState, getHelpShow, getHelpState, initialUser } from 'store/storeValtio.js';
import { generateUniqueId, getNowISO, parseForm, validateEmail } from 'helpers/generalHelpers.js';
import { addUserToDb } from 'store/localDb';
import { adjustDemoData, loadDataFromFirestore } from 'components/settings/loadData';
import helpIcon from 'icons/help-32.png';

export default function NewUserForm() {
  const currentUserId = getCurrentUserId();
  //console.log('NewUserForm', currentUserId);
  let additionalUser = false;
  if (currentUserId) {
    console.log("adding additional user");
    additionalUser = true;
  }

  const [submitError, setSubmitError] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [ errors, setErrors ] = useState()
  const navigate = useNavigate();
  
  function help() {
    console.log('help', getHelpState());
    updateHelpState(true, 'NewUser');
  }

  function exit(e) {
    e.preventDefault();
    console.log('ProfileForm back');
    navigate(-1);
  }

  async function handleSubmit(e) {
    e.preventDefault()
    console.log('submit');
    setSubmitting(true);
    const formItems = e.target;
    console.log('formItems', formItems);
    var formVals = parseForm(formItems);
    console.log('formVals', formVals);

    // get our new errors
    const fe = findFormErrors(formVals)
    console.log('form errors: ', fe);
    if (fe) {
      setSubmitting(false);
      return;
    }

    var newUser = {...initialUser};
    newUser.userId = generateUniqueId();
    newUser.displayName = formVals.displayName;
    newUser.firstName = formVals.firstName;
    newUser.lastName = formVals.lastName;
    newUser.email = formVals.email;
    newUser.awakeTime = formVals.awakeTime;
    newUser.bedTime = formVals.bedTime;

    try {
      setUsersListLoaded(false);
      setUserStateLoaded(false);
      localStorage.removeItem('currentUser');
      localStorage.setItem('currentUser', newUser.userId );
      console.log('updated localStorage', localStorage.getItem("currentUser"));
      let response = await addUserToDb(newUser);
      await response;
      const newUserState = {
        currentUserId: newUser.userId,
        currentUser: newUser,
        loaded: true,
        authenticated: true,
      }
      updateUserState(newUserState);

    } catch (error) {
      console.log(error.message);
      setSubmitError(error.message);
    } finally {
      resetAllLoaded();
      //setSubmitting(false);
      navigate('/');
    }
  }

  function handleBlur(e) {
  }

  function findFormErrors(vals) {
    const isValidEmail = validateEmail(vals.email);
    if (!isValidEmail) {
      setErrors('Email format is invalid!');
      return true;
    }
    if ( !vals.displayName || vals.displayName === '' ) {
      setErrors('Display Name cannot be blank!');
      return true;
    }
    if ( !vals.firstName || vals.firstName === '' ) {
      setErrors('First Name cannot be blank!');
      return true;
    }
    if ( !vals.lastName || vals.lastName === '' ) {
      setErrors('Last Name cannot be blank!');
      return true;
    }
    setErrors(null);
    return false;
  }

  async function loadDemo()
  {
    setSubmitting(true);
    await loadDataFromFirestore('demo@demodata.com');
    await adjustDemoData();
    navigate('/');
  }

  return (
    <div className='w-full'>

      <div className='bg-gray-100 flex flex-col pt-4 pb-2 tablet:px-8'>
        <div className='mx-auto w-full max-w-md mb-4'>
          <h2 className='mt-4 text-center text-3xl font-extrabold text-gray-900'>
            I Took It When
          </h2>
          {additionalUser && 
          <h2 className='mt-1 text-center text-2xl font-bold text-gray-900'>
            Enter new user information
          </h2>
          }
          {!additionalUser && 
          <h2 className='mt-1 text-center text-2xl font-bold text-gray-900'>
            Enter user to continue
          </h2>
          }
        </div>
      </div>

    
      <div className='min-h-screen bg-gray-100 flex flex-col px-4 tablet:px-6'>
        <div className='mt-4 mx-auto w-full max-w-md'>
        {(errors || submitError) && (
          <div
            className='bg-red-100 rounded-lg py-2 px-10 mb-3 text-base text-red-700'
            role='alert'
          >
            {errors}{submitError}
          </div>
        )}

         <div className='bg-white py-8 shadow rounded-lg px-10'>
            <form className='mb-0 space-y-6' onSubmit={handleSubmit}>
              <div>
                <label htmlFor='displayName' className='block text-sm font-medium text-gray-700' > Display name </label>
                <div className='mt-1'>
                  <input 
                    className='formText'
                    onBlur={handleBlur} 
                    id='displayName' 
                    name='displayName' 
                    type='text' 
                    autoComplete='name' 
                    /> 
                </div>
              </div>
              <div>
                <label htmlFor='firstName' className='block text-sm font-medium text-gray-700' > First name </label>
                <div className='mt-1'>
                  <input 
                    className='formText'
                    onBlur={handleBlur} 
                    id='firstName' 
                    name='firstName' 
                    type='text' 
                    autoComplete='name' 
                    /> 
                </div>
              </div>
              <div>
                <label htmlFor='lastName' className='block text-sm font-medium text-gray-700' > Last name </label>
                <div className='mt-1'>
                  <input 
                    className='formText'
                    onBlur={handleBlur} 
                    id='lastName' 
                    name='lastName' 
                    type='text' 
                    autoComplete='name' 
                    /> 
                </div>
              </div>
              <div>
                <label htmlFor='email' className='block text-sm font-medium text-gray-700' > Email address </label> 
                <div className='mt-1'>
                  <input 
                    className='formText'
                    onBlur={handleBlur} 
                    id='email' 
                    name='email' 
                    type='email' 
                    autoComplete='email' 
                    /> 
                </div>
              </div>
              <div className='mt-1 flex justify-between'>
                <div className='w-[45%]'>
                  <label htmlFor='awakeTime' className='block text-sm font-medium text-gray-700' >Awake Time</label>
                  <div className='mt-1'>
                    <input 
                      className='formText'
                      onBlur={handleBlur} 
                      id='awakeTime' 
                      name='awakeTime' 
                      type='text' 
                      autoComplete='text' 
                      defaultValue="6:00AM"
                      /> 
                  </div>
                </div>
                <div className='w-[45%] float-right'>
                  <label htmlFor='bedTime' className='block text-sm font-medium text-gray-700' >Bed Time</label>
                  <div className='mt-1'>
                    <input 
                      className='formText'
                      onBlur={handleBlur} 
                      id='bedTime' 
                      name='bedTime' 
                      type='text' 
                      autoComplete='text' 
                      defaultValue="10:00PM"
                      /> 
                  </div>
                </div>
              </div>
              <div className='flex justify-between'>
                <button type='submit' disabled={submitting} className='okBtn'>Add User</button> 
                <button onClick={exit} type='button' className='cancelBtn'>Cancel</button> 
              </div>
            </form>
          </div>
          <div className='flex justify-center items-center mt-4'>
            <button className='hpBtn disabled:opacity-60' disabled={submitting} onClick={()=>loadDemo()} >
              Load Demo Data
            </button>
            <img className='ml-6 w-10 hover:cursor-pointer' src={helpIcon} onClick={()=>help()} alt=""/>
          </div>
        </div>
      </div>
    </div>
  );
}
